// extracted by mini-css-extract-plugin
module.exports =  {"phone":"a10a3f92e9--phone--yMXAf","phone-size-xs":"a10a3f92e9--phone-size-xs--UZfGq"};